import { render, staticRenderFns } from "./EpicIntegration.vue?vue&type=template&id=a0531d9e&scoped=true&"
import script from "./EpicIntegration.vue?vue&type=script&lang=js&"
export * from "./EpicIntegration.vue?vue&type=script&lang=js&"
import style0 from "./EpicIntegration.vue?vue&type=style&index=0&id=a0531d9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0531d9e",
  null
  
)

export default component.exports